import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function DifferentiationSection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refCards, style: styleCards } = useScrollReveal({
    threshold: 0.1,
    distance: 28,
    duration: 800,
    delay: 200,
  });

  return (
    <section className="w-full bg-brand-black py-20 md:py-28 px-6 lg:px-[7%]">
      <div ref={ref} style={style} className="text-center max-w-2xl mx-auto">
        <span className="font-sans text-brand-sage text-[11px] tracking-[0.2em] uppercase font-medium">
          Diferenciación
        </span>
        <h2 className="font-serif text-white text-[clamp(1.8rem,4vw,2.8rem)] leading-[1.3] mt-4">
          Esto no es lo que conoces
        </h2>
      </div>
      <div
        ref={refCards}
        style={styleCards}
        className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-12 max-w-5xl mx-auto"
      >
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-6">
            <div className="w-6 h-6 flex items-center justify-center text-white/60">
              <i className="ri-close-circle-line text-xl" />
            </div>
          </div>
          <h3 className="font-serif text-white text-xl font-medium">
            No es un personal shopper convencional
          </h3>
          <p className="font-sans text-white/50 text-sm leading-relaxed mt-4">
            No te acompañamos de tienda en tienda a comprar al azar. Diseñamos
            un sistema basado en tu perfil, tus objetivos y tu contexto real.
          </p>
        </div>
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-12 h-12 mx-auto rounded-full bg-white/10 flex items-center justify-center mb-6">
            <div className="w-6 h-6 flex items-center justify-center text-white/60">
              <i className="ri-close-circle-line text-xl" />
            </div>
          </div>
          <h3 className="font-serif text-white text-xl font-medium">
            No es solo ropa
          </h3>
          <p className="font-sans text-white/50 text-sm leading-relaxed mt-4">
            Tu imagen incluye cabello, barba, piel, definición estética y
            comunicación no verbal. Trabajamos el conjunto, no la prenda
            aislada.
          </p>
        </div>
        <div className="bg-brand-sage/10 border border-brand-sage/30 rounded-2xl p-8 md:p-10 text-center">
          <div className="w-12 h-12 mx-auto rounded-full bg-brand-sage/30 flex items-center justify-center mb-6">
            <div className="w-6 h-6 flex items-center justify-center text-brand-sage">
              <i className="ri-check-line text-xl" />
            </div>
          </div>
          <h3 className="font-serif text-white text-xl font-medium">
            Es un sistema estructurado y continuo
          </h3>
          <p className="font-sans text-white/50 text-sm leading-relaxed mt-4">
            No es una sesión puntual. Es un método que evoluciona contigo, con
            seguimiento, ajustes y una plataforma digital que te acompaña día a
            día.
          </p>
        </div>
      </div>
    </section>
  );
}